import { render, staticRenderFns } from "./CourseCataloguePopup.vue?vue&type=template&id=72679cd0&"
import script from "./CourseCataloguePopup.vue?vue&type=script&lang=js&"
export * from "./CourseCataloguePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports